import { props } from "bluebird";
import React from "react";

import Styles from "./Modal.module.css";

const Modal = (props) => {
  return (
    // backdrop
    <div className={Styles["Modal-backdrop"]}>
      {/* modal */}
      <div className={Styles["Modal"]}>{props.children}</div>
    </div>
  );
};

export default Modal;